/* YB – scripts propios. Cada init comprueba si su elemento existe. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.yb-reveal:not(.yb-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('yb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('yb-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-yb-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-yb-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        img.style.transform = 'translateY(' + off.toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-yb-contar]');
    if (!nums.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-yb-contar')) || 0;
      var dec = (el.getAttribute('data-yb-contar').split(/[.,]/)[1] || '').length;
      var suf = el.getAttribute('data-yb-sufijo') || '';
      if (reduce) { el.textContent = fin.toFixed(dec).replace('.', ',') + suf; return; }
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / 1600, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec).replace('.', ',') + suf;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initProducto() {
    document.querySelectorAll('[data-yb-producto]').forEach(function (root) {
      if (root.dataset.ybListo) return;
      root.dataset.ybListo = '1';
      var principal = root.querySelector('[data-yb-principal]');
      root.querySelectorAll('[data-yb-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          principal.src = btn.getAttribute('data-src');
          principal.alt = btn.getAttribute('data-alt') || '';
          root.querySelectorAll('[data-yb-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });

      var cant = root.querySelector('[data-yb-cantidad]');
      root.querySelectorAll('[data-yb-cant-btn]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(cant.value, 10) || 1;
          v += parseInt(b.getAttribute('data-yb-cant-btn'), 10);
          cant.value = Math.max(1, v);
        });
      });

      var datos = root.querySelector('[data-yb-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var form = root.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var precio = root.querySelectorAll('[data-yb-precio]');
      var antes = root.querySelectorAll('[data-yb-precio-antes]');
      var botones = root.querySelectorAll('[data-yb-comprar]');
      var formato = root.getAttribute('data-yb-moneda') || '{{amount_with_comma_separator}} €';
      var txtComprar = root.getAttribute('data-yb-txt-comprar');
      var txtAgotado = root.getAttribute('data-yb-txt-agotado');

      function dinero(c) {
        var n = (c / 100).toFixed(2);
        var coma = n.replace('.', ',');
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k.indexOf('comma') > -1) return coma;
          if (k.indexOf('no_decimals') > -1) return Math.round(c / 100);
          return n;
        });
      }

      function actualizar() {
        var sel = [];
        root.querySelectorAll('[data-yb-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel.push(c ? c.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!v) {
          botones.forEach(function (b) { b.disabled = true; b.textContent = txtAgotado; });
          return;
        }
        if (inputId) inputId.value = v.id;
        precio.forEach(function (p) { p.textContent = dinero(v.price); });
        antes.forEach(function (p) {
          if (v.compare_at_price && v.compare_at_price > v.price) { p.textContent = dinero(v.compare_at_price); p.hidden = false; }
          else { p.hidden = true; }
        });
        botones.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? txtComprar : txtAgotado; });
        if (v.featured_image && principal) { principal.src = v.featured_image.src; }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.querySelectorAll('[data-yb-opcion] input').forEach(function (i) { i.addEventListener('change', actualizar); });

      // Barra fija de compra en móvil
      var barra = root.querySelector('[data-yb-sticky]');
      var zona = root.querySelector('[data-yb-zona-compra]');
      if (barra && zona && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          barra.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(zona);
        barra.querySelector('button').addEventListener('click', function () {
          var b = form.querySelector('[type="submit"]');
          if (b && !b.disabled) b.click();
        });
      }

      // Añadir al carrito con el cajón de Dawn si existe; si no, envío normal.
      if (form) {
        form.addEventListener('submit', function (ev) {
          var drawer = document.querySelector('cart-drawer');
          if (!drawer || !window.fetch) return;
          ev.preventDefault();
          var fd = new FormData(form);
          fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
          fd.append('sections_url', window.location.pathname);
          botones.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
          fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }
          }).then(function (r) { return r.json(); }).then(function (res) {
            botones.forEach(function (b) { b.removeAttribute('aria-busy'); });
            if (res.status) { form.submit(); return; }
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          }).catch(function () { form.submit(); });
        });
      }
    });
  }

  function initTodo() { initReveals(); initParallax(); initCifras(); initProducto(); }
  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
